<template>
  <div id="app">
    <header class="d-flex justify-space-between align-center">
      <span>
        . x VOS x .
        <router-link style="color: white;" to="/rcrdr">Rcrdr</router-link>
        <router-link style="color: white;" to="/loopr">Loopr</router-link>
        <router-link style="color: white;" to="/space">Space</router-link>
      </span>
      <VUBall />
    </header>
    <main>
      <router-view v-if="canStart" />

      <div v-else class="modal-starter">
        <button @click="setupContext()">Start Kicking Ass</button>
      </div>
    </main>
  </div>
</template>

<script>
import VUBall from '@/components/VUBall';

export default {
  name: 'app',
  components: {
    VUBall,
  },

  data() {
    return {
      canStart: false,
    };
  },

  mounted() {
    console.log('app started');
  },
  methods: {
    setupContext() {
      // monkeypatch Web Audio
      window.AudioContext =
        window.AudioContext || window.webkitAudioContext || null;

      if (!AudioContext) {
        console.error('THERE IS NO AUDIO CONTEXT HERE!  FULL STOP, BABY');
        return;
      }
      // grab an audio context
      window.audioContext = new AudioContext();

      // // Attempt to get audio input
      // try {
      //   // ask for an audio input
      //   navigator.getUserMedia(
      //     {
      //       audio: true,
      //       video: false,
      //     },
      //     this.gotStream,
      //     this.didntGetStream,
      //   );
      // } catch (e) {
      //   console.log(`getUserMedia threw exception :${e}`);
      // }


      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then((stream) => {
          console.log('gotStream started');

          // Create an AudioNode from the stream.
          window.userMediaStreamSource = window.audioContext.createMediaStreamSource(
            stream,
          );

          this.canStart = true;
        },
        )
        .catch((inErr) => {
          console.log('Stream generation failed.');
          console.log(inErr);
        });
    },

    didntGetStream() {
      console.log('Stream generation failed.');
    },
    gotStream(stream) {
      console.log('gotStream started');

      // Create an AudioNode from the stream.
      window.userMediaStreamSource = window.audioContext.createMediaStreamSource(
        stream,
      );

      this.canStart = true;
    },
  },
};
</script>

<style>
body {
  margin: 0;
  background: black;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #aeb3b8;
  background: #35495e
}

main {
  text-align: center;
  margin-top: 40px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495e;
  color: #eee;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: 0.02em;
  font-weight: 400;
  box-sizing: border-box;
}

.d-flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.justify-space-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.align-center {
  align-items: center;
}
.align-start {
  align-items: flex-start;
}

.modal-starter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: black;
}

.modal-starter button {
  background-color: #35495e;
  color: #ffffff;
  font-size: 24px;
  width: 250px;
  height: 100px;
  margin: auto;
  margin-top: 200px;
  border: none;
  border-radius: 5px;
  box-shadow: 5px 5px 15px rgba(0,0,0,0.3);
}
</style>



// WEBPACK FOOTER //
// src/App.vue